import { db, storage } from "../firebase";
import {
  setDoc,
  getDocs,
  collection,
  doc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import { ref, uploadBytes, deleteObject, listAll } from "firebase/storage";

// ADD file
export const addFile = (file) => ({
  type: "ADD_FILE",
  file,
});

export const startAddFile = (fileData = {}, files, type = "cpapfile") => {
  return async (dispatch) => {
    const {
      title = "",
      detail = "",
      productId = "",
      hn = "",
      orderId = "",
      createBy = "",
      createAt = 0,
    } = fileData;
    const file = { title, detail, productId, createBy, createAt,
      ...(hn ? { hn, orderId } : {}) };
    const ownerId = hn || productId;
    if (!ownerId || typeof ownerId !== "string" || !ownerId.trim() || ownerId.includes("/")) {
      throw new Error("No CPAP product is linked. Reload the patient and check the CPAP purchase record.");
    }

    const docRef = doc(collection(db, hn ? "patients" : "products", ownerId, type));
    const folder = hn ? "patientcpapfiles" : `${type}s`;
    const uploadedRefs = [];
    const attachments = Array.from(files || []);
    try {
      for (const item of attachments) {
        const storageRef = ref(storage, `${folder}/${ownerId}/${docRef.id}/${item.name}`);
        await uploadBytes(storageRef, item);
        uploadedRefs.push(storageRef);
      }
      // Publish a complete record only after all attachments are available.
      const savedFile = { ...file, cpapFile: attachments.map((item) => item.name) };
      await setDoc(docRef, savedFile);
      const result = { id: docRef.id, ...savedFile };
      dispatch(addFile(result));
      return result;
    } catch (error) {
      await Promise.all(uploadedRefs.map(async (storageRef) => {
        try { await deleteObject(storageRef); }
        catch (cleanupError) { console.warn("Unable to clean up CPAP file upload", cleanupError); }
      }));
      throw error;
    }
  };
};

// REMOVE File
export const removeFile = ({ id } = {}) => ({
  type: "REMOVE_FILE",
  id,
});

export const startRemoveFile = ({ productId, hn, id, type = "cpapfile" }) => {
  return async (dispatch) => {
    if (hn) {
      const files = await listAll(ref(storage, `patientcpapfiles/${hn}/${id}`));
      await Promise.all(files.items.map(async (itemRef) => {
        try { await deleteObject(itemRef); }
        catch (error) { if (error.code !== "storage/object-not-found") throw error; }
      }));
      await deleteDoc(doc(db, "patients", hn, type, id));
      dispatch(removeFile({ id }));
      return;
    }
    const docRef = doc(db, "products", productId, type, id);
    return await deleteDoc(docRef).then(() => {
      const storageRef = ref(storage, `${type}s/${productId}/${id}`);
      listAll(storageRef).then((res) => {
        res.items.forEach((itemRef) => {
          deleteObject(itemRef);
        });
      });

      dispatch(removeFile({ id }));
    });
  };
};

// SET Report
export const setFiles = (files) => ({
  type: "SET_FILE",
  files,
});
export const startSetFiles = (productId, type = "cpapfile", { hn, orderId } = {}) => {
  return async (dispatch) => {
    const refs = [];
    if (productId) refs.push(collection(db, "products", productId, type));
    if (hn) {
      const patientRef = collection(db, "patients", hn, type);
      refs.push(orderId ? query(patientRef, where("orderId", "==", orderId)) : patientRef);
    }
    const snapshots = await Promise.all(refs.map((ref) => getDocs(ref)));
    const files = [];
    snapshots.forEach((snapshot) => {
      snapshot.forEach((childSnapshot) => {
        files.push({
          id: childSnapshot.id,
          ...childSnapshot.data(),
        });
      });

    });
    dispatch(setFiles(files));
    return files;
  };
};
